"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInterfaceName = function (pkgJson) {
    var strReplace = "@microchip/";
    var interfaceName;
    if (pkgJson) {
        interfaceName = pkgJson["name"];
        if (interfaceName) {
            interfaceName = interfaceName.replace(strReplace, "");
        }
    }
    if (!interfaceName) {
        throw new Error("Invalid Interface Name...!");
    }
    return interfaceName;
};
exports.getInterfaceVersion = function (pkgJson) {
    var versionRegex = new RegExp("\\d+.\\d+.\\d+");
    var version;
    if (pkgJson) {
        version = pkgJson["version"];
    }
    if (!version && !versionRegex.test(version)) {
        throw new Error("Invalid Interface Version...!");
    }
    return version;
};
